module.exports = __webpack_public_path__ + "media/images/undraw-texting-playbook-eec1fa26caddda4a92432ac0bf47feee.png";